import ApiService from '@/services/core/api.service'

const SMerchant = {
  async get (query = '') {
    return ApiService.get(`admin/accounts/merchants?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/accounts/merchants', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/accounts/merchants/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`admin/accounts/merchants/${payload.id}`)
  }
}

export default SMerchant
